export default {"src":"/_next/static/media/CPNG.c8e8c710.svg","height":18,"width":18};